import styled from 'styled-components';
import { FC } from 'react';


const StyledTemplatesTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
  margin-bottom: ${({ theme }) => theme.spacing.medium};

  table {
    width: 100%;
    border-collapse: collapse;
  }

  thead {
    border-bottom: 1px solid lightgray;
  }

  th,
  td {
     &:not(:first-child) {
       text-align: center;
     }
  }

  tr {
    border-bottom: 1px solid ${({ theme }) => theme.palette.stroke};
  }

  th {
    text-align: left;

    &:not(:first-child) {
      text-align: center;
    }
  }

  tbody tr:hover {
    background-color: #f9f9f9;
  }

  .select-all {
    height: 100%;
    align-items: center;

    input {
      margin-right: ${({ theme }) => theme.spacing.small};
    }
  }
`;

export const DocumentOutputTable: FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <StyledTemplatesTable>
      <table>
        { children }
      </table>
    </StyledTemplatesTable>
  )
}
